export const GOAL_PROGRESS = 'goal_progress';
export const GOAL_RELATION = 'goal_relation';
export const GOAL_PLANNING = 'goal_planning';
export const GOAL_CYCLE = 'goal_cycle';
export const GOAL_LAST_GOAL_ACTIVITY_MESSAGE = 'goal_last_goal_activity_message';
export const GOAL_SELF = 'goal_self';
export const USER_NAME = 'user_name';
export const TIME_DIFF = 'time_diff';
